let authorization = {
  title: "应用权限委托",
  columns: {
    appName: "委托应用名称",
    actionType: "操作",
    consigneeName: "被委托人",
    perm:'是否有权',
    device: "委托时间",
    action: "操作",
    startTime:"委托开始时间",
    endTime:"委托结束时间",
  },
  noAccess:'无权限',
  beoverdue:'已过期',
  add:'添加委托',
  delecteall:'批量取消',
  warn:'请选择您要取消的委托',
  edit:'编辑',
  cancel:'取消',
  type: "操作类型",
  result: "操作结果",
  time: "操作时间",
  startTime:"委托开始时间",
  endTime:"委托结束时间",
  dialogTitle:'确定要取消委托吗？',
  appName: "委托应用名称",
  consigneeName: "被委托人",
  details: "操作记录详情",
  tip:{
    appName:'请选择委托应用',
    consigneeName:'请选择被委托人',
    startTime:'请选择委托开始时间',
    endTime:'请选择委托结束时间',
    timeValid:'委托结束时间要大于委托开始时间',
    searchName:'输入完整用户名,按<kbd>Enter</kbd>进行搜索',
    searchEnterNoFind:'没有找到{0}',
    user:'用户'
  },
  selectType: {
    type01: '全部',
    type02: '登录',
    type03: '登出',
    type04: '绑定',
    type05: '修改',
    type06: '重置',
    type07: '解绑',
    type08: '激活',
    type09: '访问',
    type10: '发送',
  },
  resultType: {
    label01: "全部",
    label02: "失败",
    label03: "成功",
  },
  entrustmentRecord:'委托记录',
  entrustmentRecordDetail: {
    consigneeAppName:"委托应用名称",
    consigneeName:"被委托人",
    startTime:"委托开始时间",
    endTime:"委托结束时间",
    createTime:"操作时间",
    status:"当前状态"
  },
  status: {
    0: "已取消",
    1: "生效中",
    2: "已失效",
    3: "已过期",
  },
}

export default authorization
